import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[appFocusNextOnEnter]',
  standalone: true
})
export class FocusNextOnEnterDirective {

  public constructor() {
  }

  @HostListener('keydown.enter', ['$event'])
  private onSubmit(keyboardEvent: KeyboardEvent): void {
    try {
      keyboardEvent.preventDefault();
      keyboardEvent.stopPropagation();

      const target: HTMLInputElement = keyboardEvent.target as HTMLInputElement;
      const form: HTMLFormElement = target.form;

      const inputs: HTMLInputElement[] = Array.from(form.querySelectorAll('input')) as HTMLInputElement[];

      const currentInput: HTMLInputElement = keyboardEvent.target as HTMLInputElement;
      const currentIndex: number = inputs.indexOf(currentInput);

      const inputsWithTabIndex: HTMLInputElement[] = inputs.filter(input => input.tabIndex !== undefined && input.tabIndex !== null && !isNaN(input.tabIndex));

      if (currentInput.tabIndex !== undefined && currentInput.tabIndex !== null && !isNaN(currentInput.tabIndex)) {
        const nextInputWithHigherTabIndex = inputsWithTabIndex.find(input => input.tabIndex > currentInput.tabIndex);
        if (nextInputWithHigherTabIndex) {
          nextInputWithHigherTabIndex.focus();
          return;
        }
      }

      if (currentIndex < inputs.length - 1) {
        const nextInput: HTMLInputElement = inputs[currentIndex + 1];
        nextInput.focus();
      }
    } catch (err: any) {
      // Don't break on this feature.
      console.warn(err);
    }
  }

}
